import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Grid,
  Paper,
  Toolbar,
  makeStyles,
  Typography,
  TextField,
  Button,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TablePagination,
} from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import { debounce } from 'lodash';
import routes from '../../Utils/routes.json';
import KenGrid from '../../global_components/KenGrid';
import KenSelect from '../../global_components/KenSelect';
import KenCheckbox from '../../global_components/KenCheckbox/index';
import KenButton from '../../global_components/KenButton';
import KenLoader from '../../Components/KenLoader/index';
import KenSnackbar from '../../Components/KenSnackbar/index';
import KenDialogBox from '../../global_components/KenDialogBox';
import SearchBox from '../../Components/SearchBox/index';
import KenCard from '../../global_components/KenCard';
import {
  getDataForCourseEnrolment,
  getUserData,
} from '../../Utils/apiServices';
// import { } from 'react-icons/ai';
import './styles.scss';
import { UserDetails } from './data.json';
import FacultyProfile from '../AcademicsPlanner/FacultyProfiles/facultyProfile';
import StudentProfile from '../AcademicsPlanner/StudentsProfile/index';
import { RiCheckFill } from 'react-icons/ri';
import { AiOutlineFilter } from 'react-icons/ai';
import TablePaginationActions from '../../global_components/KenGrid/TablePaginationActions';
import { Country, State, City } from 'country-state-city';

const useStyles = makeStyles((theme) => ({
  header: {
    background: '#fff',
    marginTop: '15px',
    width: '100%',
  },
  title: {
    color: theme.palette.KenColors.primary,
    fontWeight: 600,
  },
  selectTabs: {
    padding: '10px',
  },
  facultyInfoSection: {
    background: '#fff',
  },
  accordionMain: {
    background: 'transparent',
  },
  accordionTable: {
    background: '#fff',
  },
  refreshBtn: {
    float: 'right',
    marginTop: '6px',
    height: '34px !important',
    marginBottom: '8px',
    fontSize: '12px',
    fontWeight: 400,
    background: '##272727  !important',
    color: '#fff',
    borderRadius: '5px',
  },
  searchFilter: {
    '&.inputInput': {
      '&:focus': {
        maxWidth: '12ch !important',
      },
    },
  },
  courseList: {
    minHeight: '45px',
    background: '#fff',
    marginTop: '10px',
    width: '100%',
  },
  tableText: {
    position: 'absolute',
    top: '58%',
    right: '52%',
    transform: 'translate(50%, -50%)',
    display: 'flex',
  },
  profile: {
    color: theme.palette.KenColors.primary,
    cursor: 'pointer',
    fontSize: 12,
    textAlign: 'left',
    paddingLeft: '10px',
  },
  searchBar: {
    position: 'relative',
    top: 4,
  },
  searchFilter: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'right',
  },
  applyBtn: {
    justifyContent: 'right',
    marginTop: '13px',
  },
  addusersbtn: {
    float: 'right',
    marginTop: '6px',
    height: '34px !important',
    marginBottom: '8px',
    fontSize: '12px',
    fontWeight: 400,
    background: '##272727  !important',
    color: '#fff',
    borderRadius: '5px',
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  addbtn: {
    marginTop: 'auto',
    height: '34px !important',
    marginLeft: '10px',
  },
}));

export default function Users(props) {
  const { variant } = props;

  // const variant = "Faculty";

  const classes = useStyles();
  const userDetails = localStorage.getItem('userDetails');
  const [data, setData] = React.useState([]);
  const [usersData, setusersData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [selectDepartmentOption, setDepartmentOption] = useState([]);
  const [selectProgramOption, setProgramOption] = useState([]);
  const [selectProgramPlanOption, setProgramPlanOption] = useState([]);
  const [selectTermOption, setTermOption] = useState([]);
  const [facultyInfo, setFacultyInfo] = useState({
    department: '',
    program: '',
    programPlan: '',
    term: '',
    type:'',
    country:'',
  });
  const [type, setType] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [term, setTerm] = useState('');
  const [department, setDepartment] = useState('');
  const [program, setProgram] = useState('');
  const [programPlan, setProgramPlan] = useState('');
  const [filterData, setFilterData] = useState([]);
  const [studentInfo, setStudentInfo] = useState({});
  const [searchString, setSearchString] = useState('');
  const [profileDialog, setProfileDialog] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [clear, setClear] = useState(false);
  const [selectedPreview, setSelectedPreview] = useState({});
  const [pageNO, setpageNO] = useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  //country
  const [selectCountry, setSelectCountry] = useState('');

  const [countryDropdownOptions, setcountryDropdownOptions] = useState(
    Country.getAllCountries().map((countries, index) => {
      return {
        label: countries.name,
        value: countries.name,
        // value: countries.isoCode,
      };
    })
  );

  // SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  // Message Modal
  const [messageDialog, setMessageDialog] = useState(false);
  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  function handleDialogcancel() {
    setMessageDialog((prevState) => !prevState);
    setusersData([]);
  }
  const handleClick = () => {
    handleMessageDialog();
  };

  //mui model
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Profile Cell
  const ProfileCell = (row) => {
    const classes = useStyles();
    const { contactName, type } = row.row.values;
    return (
      <Typography
        className={classes.profile}
        onClick={() => onProfileView(row?.row?.original)}
      >
        {contactName}
      </Typography>
    );
  };

  //type options
  const searchType = [
    {
      label: 'Faculty',
      value: 'Faculty',
    },
    {
      label: 'Student',
      value: 'Student',
    },
    {
      label: "All",
      value:'All',
    },
  ];

  const columns1 = [
    {
      Header: 'Name',
      accessor: 'contactName',
      Cell: ProfileCell,
      disableGlobalFilter: false,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ value }) => {
        return <a href={`mailto:${value}`}>{value}</a>;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: ({ value }) => {
        return <a href={`tel:${value}`}>{value}</a>;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Gender',
      accessor: 'gender',
      disableGlobalFilter: false,
    },
    {
      Header: 'Type',
      accessor: 'recordType',
      disableGlobalFilter: false,
    },
  ];

  // Columns
  const columns = [
    {
      Header: '',
      accessor: 'checked',
      Cell: ({ value, row }) => {
        return (
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={value}
            onChange={(event) => selectedCheckBoxItem(event, row, data)}
            color="primary"
          />
        );
      },
      disableGlobalFilter: true,
    },
    {
      Header: 'Name',
      accessor: 'contactName',
      Cell: ProfileCell,
      disableGlobalFilter: false,
    },
    {
      Header: 'Email',
      accessor: 'email',
      Cell: ({ value }) => {
        return <a href={`mailto:${value}`}>{value}</a>;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Phone',
      accessor: 'phone',
      Cell: ({ value }) => {
        return <a href={`tel:${value}`}>{value}</a>;
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Gender',
      accessor: 'gender',
      disableGlobalFilter: false,
    },
    {
      Header: 'Type',
      accessor: 'recordType',
      disableGlobalFilter: false,
    },
  ];

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };
  const handleSnackbarOpen = (severity, message) => {
    setLoading(false);
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const selectedCheckBoxItem = (event, row, data) => {
    if (event.target.checked) {
      usersData.push(row.original);
      // setusersData(tempData)
    } else if (!event.target.checked) {
      usersData.splice(row.index, 1);
    }
    // tempData[row.original].checked = event.target.checked;
    // setData(tempData);
    console.log('checked', usersData);
  };
  const handleChangeDepartment = (e) => {
    setFacultyInfo({ ...facultyInfo, department: e.target.value });
    setDepartment(e.target.value);
    console.log(department);
    const ProgramOption = [];
    ProgramOption.push({
      label: '-Select-',
      value: '',
    });
    const dataS = Object.entries(
      filterData.AcdemicProgramsForEachDepartment
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      } else {
        return false;
      }
    });
    console.log(dataS);
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        ProgramOption.push({
          label: items.AcademicProgramName,
          value: items.AcademicProgramId,
        });
      });
    }
    setProgramOption(ProgramOption);
  };
  const handleChangeProgram = (e) => {
    setFacultyInfo({ ...facultyInfo, program: e.target.value });

    setProgram(e.target.value);
    // For Program Plan
    const ProgramPlanOption = [];
    ProgramPlanOption.push({
      label: '-Select-',
      value: '',
    });
    const dataS2 = Object.entries(
      filterData.ProgramPlanForEachAcedemicProgram
    ).filter((item) => {
      if (item[0] == e.target.value) {
        return item;
      }
    });
    if (dataS2.length > 0) {
      dataS2[0][1].map((items) => {
        ProgramPlanOption.push({
          label: items.ProgramPlanName,
          value: items.ProgramPlanId,
        });
      });
    }
    setTermOption([]);
    setProgramPlanOption(ProgramPlanOption);
  };
  const handleChangeProgramPlan = (e) => {
    setTermOption([]);
    setFacultyInfo({ ...facultyInfo, programPlan: e.target.value });

    setProgramPlan(e.target.value);
    const TermOption = [];
    TermOption.push({
      label: '-Select-',
      value: '',
    });
    const dataS = Object.entries(filterData.TermForEachProgramPlan).filter(
      (item) => {
        if (item[0] == e.target.value) {
          return item;
        }
      }
    );
    if (dataS.length > 0) {
      dataS[0][1].map((items) => {
        TermOption.push({
          label: items.TermName,
          value: items.TermId,
        });
      });
    }
    setTermOption(TermOption);
  };
  const handleChangeTerm = (e) => {
    setTerm(e.target.value);
    setFacultyInfo({ ...facultyInfo, term: e.target.value });
  };
  const handleChangeType = (e) => {
    setFacultyInfo({ ...facultyInfo, type: e.target.value });
    let type = e.target.value;
    setType(e.target.value);
    // if (type != 'All') {
    //   setType(e.target.value);
    // }
  };
  const handleChangeCountry = (e) => {
    setFacultyInfo({ ...facultyInfo, country: e.target.value });
    setSelectCountry(`${e.target.value}`);
  };
  const onProfileView = (data) => {
    console.log('profile',data);
    if (data.recordType == 'Faculty') {
      history.push(`${routes.facultyProfile}/${data.contactId}`);
      // history.push({
      //   pathname: `${routes.facultyProfile}`,
      //   state: { contactId: data.contactId },
      // });
    } else if (data.recordType == 'Student') {
      history.push(`${routes.studentProfile}/${data.contactId}`);
      // history.push({
      //   pathname: `${routes.studentProfile}`,
      //   state: {
      //     contactId: data.contactId,
      //   },
      // });
    }

    // setProfileDialog(true);
    // setSelectedName(data?.contactName);
    // setSelectedPreview(data);
    // =======
    //     // if (data.recordType == 'Faculty') {
    //     //   history.push({
    //     //     pathname: `${routes.facultyProfile}`,
    //     //     state: data,
    //     //   });
    //     // } else if (data.recordType == 'Student') {
    //     //   history.push({
    //     //     pathname: `${routes.studentProfile}`,
    //     //     state: data,
    //     //   });
    //     // }
    //     setProfileDialog(true);
    //     setSelectedPreview(data);
    // >>>>>>> 42628d07342aabb676aecebb53be6c66fa707ca1
  };
  const profileDialogCancel = () => {
    setProfileDialog(false);
  };
  const profileDialogSubmit = () => {
    setProfileDialog(false);
  };

  const clearFilter = () => {
    const facultyInfo = {
      department: '',
      program: '',
      programPlan: '',
      term: '',
      type: '',
    };
    setSearchString('');
    setFacultyInfo(facultyInfo);
    setClear(!clear);
    // searchTable(null);
    // setSelectedName('');
    setSearchString('');
    setDepartment('');
    setTerm('')
    setTerm('')
    setProgramPlan('')
    setProgram('')
    setSelectCountry('')
    setType('');
   
    setTrigger(!trigger);
    
    console.log('department',department);
    // =======
    //     searchTable(null);
    // >>>>>>> 42628d07342aabb676aecebb53be6c66fa707ca1
  };
  const handleSubmitFilters = () => {
    setTrigger(!trigger);
    console.log(department);
  };
  // Data
  useEffect(() => {
    setLoading(true);
    let parms = `?department=${department}&acaProgram=${program}&term=${term}&programPlan=${programPlan}&name=${searchString}&pageNo=${page}&count=${rowsPerPage}&type=${variant ? variant : type==='All'?'':type}&country=${selectCountry}`;
    getUserData(parms)
      .then((res) => {
        if (res?.data.contactsList != null) {
          setData(res?.data);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [trigger,page, rowsPerPage]);

  useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    // const instituteId = '0015j00000rgtHcAAI';
    getDataForCourseEnrolment(instituteId).then((res) => {
      var DepartmentOption = [];
      DepartmentOption.push({
        label: '-select-',
        value: '',
      });
      res?.DepartmentsList.map((item) => {
        DepartmentOption.push({
          label: item.DepartmentName,
          value: item.DepartmentId,
        });
      });
      setDepartmentOption(DepartmentOption);
      setFilterData(res);
      setLoading(false);
    });
  }, []);
  // Searchbar
  const searchTableHandler = (event) => {
    if (event != null) {
      let searchString = event?.target?.value;
      if (searchString != '') {
        let columnsToFilter = [...data];
        let searchResult = columnsToFilter.filter((column) => {
          return column?.contactName != null
            ? column?.contactName
                .toLowerCase()
                .includes(searchString.toLowerCase())
            : null || column?.email != null
            ? column?.email.toLowerCase().includes(searchString.toLowerCase())
            : null || column?.phone != null
            ? column?.phone.toLowerCase().includes(searchString.toLowerCase())
            : null || column?.gender != null
            ? column?.gender.toLowerCase().includes(searchString.toLowerCase())
            : null || column?.recordType != null
            ? column?.recordType
                .toLowerCase()
                .includes(searchString.toLowerCase())
            : null;
        });
        setData(searchResult);
      } else {
        setTrigger(!trigger);
      }
    }
  };
  const searchTable = (event) => {
    if (event != null) {
      const searchString = event?.target?.value;
      setSearchString(searchString);
      debouncedSearch();
    }

    // const debouncedLogHi =debounce(()=>{
    //   setSearchString(searchInput);
    // },1000)
  };
  //   // const debouncedLogHi = debounce(searchTable, 1500);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const debouncedSearch = debounce(handleSubmitFilters, 500);

  return (
    <Grid xs={12}>
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      {loading && <KenLoader />}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Profile
          </Typography>
        }
        open={profileDialog}
        icon={<RiCheckFill />}
        handleClose={() => profileDialogCancel()}
        negativeButtonClick={() => profileDialogCancel()}
        positiveButtonClick={() => profileDialogSubmit()}
        positiveButtonText="Ok"
        maxWidth={'100%'}
        negativeButtonText="Cancel"
        dividers
      >
        <Grid xs={12}>
          {selectedPreview?.recordType == 'Faculty' ? (
            <FacultyProfile state={selectedPreview} />
          ) : (
            <StudentProfile state={selectedPreview} />
          )}
        </Grid>
      </KenDialogBox>
      <div position="static" elevation={0} className={classes.header}>
        <Toolbar style={{ minHeight: '45px' }}>
          <Typography className={classes.title}>Users</Typography>
        </Toolbar>
      </div>
      <div className={classes.courseList}>
        <Grid container xs={12}>
          <Grid container xs={12} className={classes.facultyInfoSection}>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Institute Department"
                optionalLabel={false}
                options={selectDepartmentOption}
                value={facultyInfo?.department}
                onChange={(e) => handleChangeDepartment(e)}
                placeholder="Institute Department"
                required
              />
            </Grid>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Academic Program"
                optionalLabel={false}
                options={selectProgramOption}
                value={facultyInfo?.program}
                onChange={(e) => handleChangeProgram(e)}
                placeholder="Academic Program"
                required
              />
            </Grid>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Program Plan"
                optionalLabel={false}
                options={selectProgramPlanOption}
                value={facultyInfo?.programPlan}
                onChange={(e) => handleChangeProgramPlan(e)}
                placeholder="Program Plan"
                required
              />
            </Grid>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Term"
                optionalLabel={false}
                options={selectTermOption}
                value={facultyInfo?.term}
                onChange={(e) => handleChangeTerm(e)}
                placeholder="Term"
                required
              />
            </Grid>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Type"
                optionalLabel={false}
                options={searchType}
                value={facultyInfo?.type}
                onChange={(e) => handleChangeType(e)}
                placeholder="Type"
                required
              />
            </Grid>
            <Grid xs={3} className={classes.selectTabs}>
              <KenSelect
                label="Country of Residence"
                optionalLabel={false}
                options={countryDropdownOptions}
                value={facultyInfo?.country}
                onChange={(e) => handleChangeCountry(e)}
                placeholder="Type"
                required
              />
            </Grid>
            <Grid container xs={6} className={classes.applyBtn}>
              <KenButton
                onClick={handleSubmitFilters}
                variant="primary"
                className={classes.refreshBtn}
              >
                Apply
              </KenButton>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => clearFilter()}
                variant="primary"
                edge="start"
                className={classes.addusersbtn}
                style={{ marginLeft: '10px', marginRight: '10px' }}
              >
                <AiOutlineFilter />
                Clear All
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div>
        <div className={classes.searchFilter}>
          <SearchBox
            searchHandler={searchTable}
            value={searchString}
            disableFocus={true}
          />
          {variant ? (
            <KenButton
              onClick={handleClick}
              variant="primary"
              className={classes.addbtn}
            >
              Add Users
            </KenButton>
          ) : null}
        </div>
      </div>
      <Grid xs={12}>
        <div className="users-table" style={{ width: '100%' }}>
          <KenGrid
            columns={variant ? columns : columns1}
            data={data?.contactsList}
            // pagination={{ disabled: false, rowsPerPageOptions: [25, 50, 100], pageSize: 25 }}
            toolbarDisabled={true}
            count={data.totalNoOfUsers}
          />
          <Box style={{ display: 'flex', justifyContent: 'right' }}>
            <TablePagination
              rowsPerPageOptions={[25, 50, 100]}
              colSpan={6}
              count={data.totalNoOfUsers ? data.totalNoOfUsers : data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box>
        </div>
      </Grid>
      <KenDialogBox
        // title={
        //   <Typography variant="h6" className={classes.dialogHeader}>
        //     Add Users
        //   </Typography>
        // }
        open={messageDialog}
        handleClose={() => handleDialogcancel()}
        negativeButtonClick={() => handleDialogcancel()}
        positiveButtonClick={() => handleMessageDialog()}
        positiveButtonText="submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {usersData.length > 0 ? (
              <KenGrid
                columns={columns1}
                data={usersData}
                toolbarDisabled={true}
              />
            ) : (
              <h1>User is not Selected</h1>
            )}
          </Grid>
        </Grid>
      </KenDialogBox>
    </Grid>
  );
}
